<template>
    <EntryForm :form="form"
        @form="form=$event.target.value"
        @submit="doPublish"
        :categories="categories"
        :tags="tags"
        :loaderPdf="true"
        title="Crear nuevo libro"
        buttonText="Publicar"
    />
</template>

<script>

import EntryForm from '@/components/admin/EntryForm'

export default {
    name: 'PublishBook',
    components:{
        EntryForm
    },
    data(){
        return {
            form: {
                title: '',
                thumbnail: null,
                description: '',
                selectedImage: null,
                categories: [],
                tags: []
            },
        }
    },
    methods:{
        async doPublish(image, pdf){
            const bookId = await this.$store.dispatch('book/getBookId')
            if(image){
                this.form.thumbnail = await this.$store.dispatch('utils/uploadImageAndGetUrl', {directory: `books/thumbnail/thumbnail-${bookId}`, image})
            }
            this.$store.dispatch('book/doPublish', {id: bookId, ...this.form, pdf})
        },
    },
    computed:{
        categories(){
            return require('@/assets/json/library.json').categories
        },
        tags(){
            return require('@/assets/json/library.json').tags
        }
    }

}
</script>